<template>
  <div>
    <div class="textBook">
      <br>

      <span style="color:green" v-if="saveReport">Updating......</span>


      <!-- Bulk Edit Modal -->
      <b-modal v-model="showBulkEdit" title="Bulk Edit Signature Fields" hide-footer>

        <!-- Loader overlay inside modal -->
        <div v-if="bulkupdation" class="modal-loader-overlay">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="mt-2 text-success">Updating bulk changes...</div>
        </div>

        <!-- Form content -->
        <b-form @submit.prevent="applyBulkEdit" :class="{ 'opacity-50 pointer-events-none': bulkupdation }">
          <b-form-group label="Change From" label-for="bulkFrom">
            <b-form-select id="bulkFrom" v-model="bulkEdit.from" :options="signatureOptions" value-field="id"
              text-field="name"></b-form-select>
          </b-form-group>

          <b-form-group label="Change To" label-for="bulkTo">
            <b-form-select id="bulkTo" v-model="bulkEdit.to" :options="signatureOptions" value-field="id"
              text-field="name"></b-form-select>
          </b-form-group>

          <div class="text-right">
            <b-button variant="success" type="submit" :disabled="bulkupdation">
              Update
            </b-button>
            <b-button variant="secondary" class="ml-2" @click="showBulkEdit = false" :disabled="bulkupdation">
              Cancel
            </b-button>
          </div>

        </b-form>
      </b-modal>

      <br>
      <table class="table  table-striped table-bordered">
        <tr>
          <th>Sl No</th>
          <th>Report Name</th>
          <th>
             <!-- Bulk Edit button top-right -->
            <div class="d-flex justify-content-end mb-2">
              <b-button size="sm" variant="info" @click="showBulkEdit = true">
                <i class="fas fa-edit mr-1" style="font-size: 15px !important;"></i> Bulk Edit
              </b-button>
            </div>
          </th>
        </tr>

        <!-- Course Reports -->

        <tr>
          <td colspan="3" class="text-center"><b>Course Reports</b></td>
        </tr>
        <tr v-for="(signedOfficials, reportName, cindex) in courseReportOptions" :key="reportName">
          <td>{{ cindex + 1 }}</td>
          <td>
            {{ reportName.replace(/_/g, ' ').toUpperCase() }}
            <i class="fas fa-plus-square text-primary ml-2" style="cursor: pointer; font-size: 15px!important;"
              @click="addSignatureField(reportName, 'course')">
            </i>
          </td>
          <td>
            <div v-for="(value, key) in signedOfficials" :key="key" class="d-flex align-items-center">
              <div class="ml-2">
                <div v-if="!isEditing[reportName][key]">
                  <span v-if="value">{{ getSignatureName(value) }}</span>
                  <span v-else style="color: red;">Click the edit icon to add a Signature field</span>
                  <i class="fas fa-minus-circle text-danger mx-2" style="font-size: 12px !important;"
                    @click="removeSignatureField(reportName, key, 'course')"></i>
                  <i class="fas fa-edit text-info" style="font-size: 14px !important; cursor: pointer;"
                    @click.stop="enableEditing(reportName, key)"></i>
                </div>
                <div v-else>
                  <b-row class="mx-2 my-1">
                    <b-form-select class="mr-1" style="width: 250px;" v-model="signedOfficials[key]"
                      :options="signatureOptions" value-field="id" text-field="name"></b-form-select>
                    <button class="btn btn-success btn-sm mr-2"
                      @click.stop="disableEditing(reportName, signedOfficials, key)">
                      Save Signature Field
                    </button>
                    <button class="btn btn-secondary btn-sm" @click.stop="cancelEditing(reportName, key)">
                      Cancel
                    </button>
                  </b-row>
                </div>
              </div>
            </div>
          </td>
        </tr>

        <!-- Class Reports -->
        <tr>
          <td colspan="3" style="text-align:center"><b>Class Reports</b></td>
        </tr>
        <tr v-for="(signedOfficials, reportName, cindex) in classReportOptions" :key="reportName">
          <td>{{ (Object.keys(courseReportOptions).length) + cindex + 1 }}</td>
          <td>
            {{ reportName.replace(/_/g, ' ').toUpperCase() }}
            <i class="fas fa-plus-square text-primary ml-2" style="cursor: pointer; font-size: 15px!important;"
              @click="addSignatureField(reportName, 'class')">
            </i>
          </td>
          <td>
            <div v-for="(value, key) in signedOfficials" :key="key" class="d-flex align-items-center">
              <div class="ml-2">
                <div v-if="!isEditing[reportName][key]">
                  <span v-if="value">{{ getSignatureName(value) }}</span>
                  <span v-else style="color: red;">Click the edit icon to add a Signature field</span>
                  <i class="fas fa-minus-circle text-danger mx-2" style="font-size: 12px !important;"
                    @click="removeSignatureField(reportName, key, 'class')">
                  </i>
                  <i class="fas fa-edit text-info" style="font-size: 14px !important; cursor: pointer;"
                    @click.stop="enableEditing(reportName, key)">
                  </i>
                </div>
                <div v-else>
                  <b-row class="mx-2 my-1">
                    <b-form-select class="mr-1" style="width: 250px;" v-model="signedOfficials[key]"
                      :options="signatureOptions" value-field="id" text-field="name">
                    </b-form-select>
                    <button class="btn btn-success btn-sm mr-2"
                      @click.stop="disableEditing(reportName, signedOfficials, key)">
                      Save Signature Field
                    </button>
                    <button class="btn btn-secondary btn-sm" @click.stop="cancelEditing(reportName, key)">
                      Cancel
                    </button>
                  </b-row>
                </div>
              </div>
            </div>
          </td>
        </tr>

        <!-- Survey Reports -->
        <tr>
          <td colspan="3" style="text-align:center"><b>Survey Reports</b></td>
        </tr>
        <tr v-for="(signedOfficials, reportName, cindex) in surveyReportOptions" :key="reportName">
          <td>{{ (Object.keys(courseReportOptions).length) + (Object.keys(classReportOptions).length) + cindex + 1 }}
          </td>
          <td>
            {{ reportName.replace(/_/g, ' ').toUpperCase() }}
            <i class="fas fa-plus-square text-primary ml-2" style="cursor: pointer; font-size: 15px!important;"
              @click="addSignatureField(reportName, 'survey')">
            </i>
          </td>
          <td>
            <div v-for="(value, key) in signedOfficials" :key="key" class="d-flex align-items-center">
              <div class="ml-2">
                <div v-if="!isEditing[reportName][key]">
                  <span v-if="value">{{ getSignatureName(value) }}</span>
                  <span v-else style="color: red;">Click the edit icon to add a Signature field</span>
                  <i class="fas fa-minus-circle text-danger mx-2" style="font-size: 12px !important;"
                    @click="removeSignatureField(reportName, key, 'survey')">
                  </i>
                  <i class="fas fa-edit text-info" style="font-size: 14px !important; cursor: pointer;"
                    @click.stop="enableEditing(reportName, key)">
                  </i>
                </div>
                <div v-else>
                  <b-row class="mx-2 my-1">
                    <b-form-select class="mr-1" style="width: 250px;" v-model="signedOfficials[key]"
                      :options="signatureOptions" value-field="id" text-field="name">
                    </b-form-select>

                    <button class="btn btn-success btn-sm mr-2"
                      @click.stop="disableEditing(reportName, signedOfficials, key)">
                      Save Signature Field
                    </button>
                    <button class="btn btn-secondary btn-sm" @click.stop="cancelEditing(reportName, key)">
                      Cancel
                    </button>

                  </b-row>
                </div>
              </div>
            </div>
          </td>
        </tr>

      </table>
    </div>
  </div>
</template>

<script>
//import CopyCourseProperties from "./CopyCourseProperties.vue"
export default {
  props: ["usergroup_id"],
  async created() {
    await this.prepareReportDatas();
  },
  components: {
    // CopyCourseProperties,
  },
  computed: {
    getSignatureName() {
      return (id) => {
        const option = this.signatureOptions.find(option => option.id === id);
        return option ? option.name : id; // Fallback to the ID if not found
      };
    }
  },
  data() {
    return {
      saveReport: false,
      edit: false,
      activity_name: '',
      copy_from: '',
      editbutton: 'Edit',
      courseReportOptions: [],
      classReportOptions: [],
      surveyReportOptions: [],
      isEditing: {}, // Object to track edit mode for each key
      selectedSignatures: {}, // To store selected signatures for each report
      originalSignatureValues: {},
      signatureOptions: [
        { id: 'course_in_charge', name: 'Enable Course In-Charge Signature Field' },
        { id: 'advisor', name: 'Enable Advisor Signature Field' },
        { id: 'hod', name: 'Enable HOD Signature Field' },
        { id: 'dqac', name: 'Enable DQAC Signature Field' },
        { id: 'principal', name: 'Enable Principal Signature Field' },
        { id: 'iqac', name: 'Enable IQAC Signature Field' },
        { id: 'stream_coordinator', name: 'Enable Stream Coordinator' },
        { id: 'dean_academics', name: 'Enable Dean Academics' }
      ],
      bulkupdation: false,
      showBulkEdit: false,
      bulkEdit: {
        from: null,
        to: null,
      },
    };
  },
  methods: {

    // Apply bulk edit
    async applyBulkEdit() {
      if (!this.bulkEdit.from || !this.bulkEdit.to) {
        return this.$toast.warning("Please select both 'From' and 'To' fields", { position: 'top' });
      }

      this.bulkupdation = true;

      // Helper function to return array of promises for all reports
      const updateField = (reportOptions) => {
        return Object.keys(reportOptions).map((reportName) => {
          reportOptions[reportName] = reportOptions[reportName].map((val) =>
            val === this.bulkEdit.from ? this.bulkEdit.to : val
          );
          // Return the promise from updateReport
          return this.updateReport(reportName, reportOptions[reportName], 'bulk');
        });
      };

      try {
        // Collect all update promises
        const allPromises = [
          ...updateField(this.courseReportOptions),
          ...updateField(this.classReportOptions),
          ...updateField(this.surveyReportOptions),
        ];

        // Wait until all updates are complete
        await Promise.all(allPromises);

        // After all updates
        this.showBulkEdit = false;
        this.$toast.success("Bulk update applied successfully", { position: 'top' });
        this.bulkEdit.from = "";
        this.bulkEdit.to = "";

      } catch (error) {
        console.error("Error during bulk update:", error);
        this.$toast.error("Bulk update failed", { position: 'top' });
      } finally {
        this.bulkupdation = false;
      }
    },


    async prepareReportDatas() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/reportsettings?usergroup_id=${this.usergroup_id}`;
      try {
        const response = await this.$axios.get(url);

        const reportTypes = ['courseReports', 'classReports', 'surveyReports'];

        reportTypes.forEach((type) => {
          const reportData = response.data[type] || {};

          // Store entire object of report options (e.g., courseReportOptions)
          this[`${type.replace('Reports', 'ReportOptions')}`] = reportData;

          // Loop through each report name in the group
          Object.entries(reportData).forEach(([reportName, signedOfficials]) => {
            this.$set(this.isEditing, reportName, {});

            // Loop through officials to initialize editing flags
            signedOfficials.forEach((_, index) => {
              this.$set(this.isEditing[reportName], index, false);
            });
          });
        });

      } catch (error) {
        console.error('Error fetching report data:', error);
      }
      console.log("this.isEditing", this.isEditing);
    },

    addSignatureField(reportName, reportType) {
      let signedOfficials = [];
      if (reportType === 'course') {
        signedOfficials = this.courseReportOptions[reportName];
      } else if (reportType === 'class') {
        signedOfficials = this.classReportOptions[reportName];
      } else if (reportType === 'survey') {
        signedOfficials = this.surveyReportOptions[reportName];
      }

      // Limit to a maximum of 7
      if (signedOfficials.length < 7) {
        signedOfficials.push(null);
      } else {
        return alert("Maximum limit of 7 signed officials reached.")
      }

      this.$forceUpdate();
    },

    removeSignatureField(reportName, index, reportType) {
      let signedOfficialsArray = null;

      if (reportType === 'course') {
        signedOfficialsArray = this.courseReportOptions[reportName];
      } else if (reportType === 'class') {
        signedOfficialsArray = this.classReportOptions[reportName];
      } else if (reportType === 'survey') {
        signedOfficialsArray = this.surveyReportOptions[reportName];
      }

      if (!signedOfficialsArray) return;

      // Remove the official from the array
      signedOfficialsArray.splice(index, 1);

      // Update isEditing[reportName] to match the new indexes
      if (this.isEditing[reportName]) {
        const updatedEditing = {};
        signedOfficialsArray.forEach((_, i) => {
          updatedEditing[i] = false; // Or preserve previous values if needed
        });
        this.$set(this.isEditing, reportName, updatedEditing);
      }

      this.updateReport(reportName, signedOfficialsArray);
    },

    enableEditing(reportName, key) {
      // Initialize if not present
      if (!this.originalSignatureValues[reportName]) {
        this.$set(this.originalSignatureValues, reportName, {});
      }

      // Store the original value
      const currentValue = this.getSignedOfficialsArray(reportName)[key];
      this.$set(this.originalSignatureValues[reportName], key, currentValue);

      // Enable edit mode
      this.$set(this.isEditing[reportName], key, true);
    },
    // Disable editing mode and update the report
    disableEditing(reportName, signedOfficials, key) {
      this.$set(this.isEditing[reportName], key, false);
      this.updateReport(reportName, signedOfficials);
    },
    cancelEditing(reportName, key) {
      const original = this.originalSignatureValues[reportName]?.[key];
      if (original !== undefined) {
        const signedOfficials = this.getSignedOfficialsArray(reportName);
        this.$set(signedOfficials, key, original);
      }

      this.$set(this.isEditing[reportName], key, false);
    },
    getSignedOfficialsArray(reportName) {
      if (this.courseReportOptions[reportName]) {
        return this.courseReportOptions[reportName];
      }
      if (this.classReportOptions[reportName]) {
        return this.classReportOptions[reportName];
      }
      if (this.surveyReportOptions[reportName]) {
        return this.surveyReportOptions[reportName];
      }
      return [];
    },
    // Update the report
    async updateReport(reportName, signedOfficials, $type) {
      this.saveReport = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/reportsettings`;
      try {
        await this.$axios.post(url, {
          usergroup_id: this.usergroup_id,
          report_name: reportName,
          signed_officials: signedOfficials,
        });
        if ($type != 'bulk') {
          this.$toast.success('Updated', {
            position: 'top',
            duration: 3000,
          });
        }

      } catch (error) {
        console.error('Error updating report:', error);
      } finally {
        this.saveReport = false;
      }
    },
  },

};
</script>

<style>
.textBook .ltp_credit {
  width: 25%;
  display: flex;
  justify-content: space-between;
}

.textBook .ltp_credit input {
  width: 150px;
  text-align: center;
}
</style>